import { render, staticRenderFns } from "./deliveryChargeReports.vue?vue&type=template&id=639aea3e&"
import script from "./deliveryChargeReports.vue?vue&type=script&lang=js&"
export * from "./deliveryChargeReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports